module.exports = __webpack_public_path__ + "static/media/round-cake-24px.bd51c6e3.svg";